export let products = [
  {
    avaiblity: true,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/newproducts/newproduct.png",
    id: 19,
    categoryTitle : "newCategory" , 
    tags : ['custom Pcs']  ,
  },
  {
    avaiblity: true,
    stars: 5,
    review: 1,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/newproducts/newproduct (5).png",
    id: 20,
    categoryTitle : "newCategory" , 
    tags : ['custom Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 3,
    review: 100,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/newproducts/newproduct (4).png",
    id: 21,
    categoryTitle : "newCategory" , 
    tags : ['custom Pcs']  ,
  },
  {
    avaiblity: true,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/newproducts/newproduct (5).png",
    id: 22,
    categoryTitle : "newCategory" ,
    tags : ['custom Pcs']  ,
  },
  {
    avaiblity: true,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/newproducts/newproduct (6).png",
    id: 23,
    categoryTitle : "newCategory" , 
    tags : ['custom Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/newproducts/newproduct.png",
    id: 24,
    categoryTitle : "newCategory" , 
    tags : ['custom Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 4,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/CustomBuilds/case-1.png",
    id: 25,
    categoryTitle : "custombuilds" , 
    tags : ['MSI All-IN-One Pcs','HP/Compaq Pcs' , 'case']  ,
  },
  {
    avaiblity: false,
    stars: 4,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/CustomBuilds/case-2.png",
    id: 26,
    categoryTitle : "custombuilds" , 
    tags : ['MSI All-IN-One Pcs','HP/Compaq Pcs' , 'case']  ,
  },
  {
    avaiblity: false,
    stars: 3,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/CustomBuilds/case-3.png",
    id: 27,
    categoryTitle : "custombuilds" , 
    tags : ['MSI All-IN-One Pcs','HP/Compaq Pcs' , 'case']  ,
  },
  {
    avaiblity: false,
    stars: 5,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/CustomBuilds/case-4.png",
    id: 28,
    categoryTitle : "custombuilds" , 
    tags : ['MSI All-IN-One Pcs','HP/Compaq Pcs' , 'case']  ,
  },
  {
    avaiblity: false,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/CustomBuilds/case-5.png",
    id: 29,
    categoryTitle : "custombuilds" , 
    tags : ['MSI All-IN-One Pcs','HP/Compaq Pcs' , 'case']  ,
  },
  {
    avaiblity: false,
    stars: 4,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/MsiLaptops/MsiLaptop (1).png",
    id: 30,
    categoryTitle : "Msiproductinfo" , 
    tags : ['Custom Pcs' , 'MSI All-IN-One Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 4,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/MsiLaptops/MsiLaptop (2).png",
    id: 31,
    categoryTitle : "Msiproductinfo" , 
    tags : ['Custom Pcs' , 'MSI All-IN-One Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 3,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/MsiLaptops/MsiLaptop (3).png",
    id: 32,
    categoryTitle : "Msiproductinfo" , 
    tags : ['Custom Pcs' , 'MSI All-IN-One Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 5,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/MsiLaptops/MsiLaptop (4).png",
    id: 33,
    categoryTitle : "Msiproductinfo" , 
    tags : ['Custom Pcs' , 'MSI All-IN-One Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/MsiLaptops/MsiLaptop (5).png",
    id: 34,
    categoryTitle : "Msiproductinfo" , 
    tags : ['Custom Pcs' , 'MSI All-IN-One Pcs']  ,
  },
  {
    avaiblity: false,
    stars: 5,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/Desktop/Desktop.png",
    id: 35,
    categoryTitle : "Desktops" , 
    tags : ['Case' , 'Monitor' , 'Adata' , 'Gigabyte' ,'Razor']  ,
  },
  {
    avaiblity: false,
    stars: 1,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/Desktop/Desktop1.png",
    id: 36,
    categoryTitle : "Desktops" , 
    tags : ['Case' , 'Monitor' , 'Adata' , 'Gigabyte' ,'Razor']  ,
  },
  {
    avaiblity: false,
    stars: 3,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/Desktop/Desktop2.png",
    id: 37,
    categoryTitle : "Desktops" , 
    tags : ['Case' , 'Monitor' , 'Adata' , 'Gigabyte' ,'Razor']  ,
  },
  {
    avaiblity: false,
    stars: 5,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/Desktop/Desktop.png",
    id: 38,
    categoryTitle : "Desktops" , 
    tags : ['Case' , 'Monitor' , 'Adata' , 'Gigabyte' ,'Razor']  ,
  },
  {
    avaiblity: false,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/Desktop/Desktop2.png",
    id: 39,
    categoryTitle : "Desktops" , 
    tags : ['Case' , 'Monitor' , 'Adata' , 'Gigabyte' ,'Razor']  ,
  },
  {
    avaiblity: false,
    stars: 5,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/GamingMonitor/GamingMonitor1.png",
    id: 40,
    categoryTitle: "gamingmonitor" ,
    tags : ['Monitor' , 'Msi' , 'Razor' , 'Gigabyte']  ,
  },
  {
    avaiblity: false,
    stars: 1,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/GamingMonitor/GamingMonitor.png",
    id: 41,
    categoryTitle: "gamingmonitor" ,
    tags : ['Monitor' , 'Msi' , 'Razor' , 'Gigabyte']  ,
  },
  {
    avaiblity: false,
    stars: 3,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/GamingMonitor/GamingMonitor.png",
    id: 42,
    categoryTitle: "gamingmonitor" ,
    tags : ['Monitor' , 'Msi' , 'Razor' , 'Gigabyte']  ,
  },
  {
    avaiblity: false,
    stars: 5,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/GamingMonitor/GamingMonitor1.png",
    id: 43,
    categoryTitle: "gamingmonitor" ,
    tags : ['Monitor' , 'Msi' , 'Razor' , 'Gigabyte']  ,
  },
  {
    avaiblity: false,
    stars: 2,
    review: 10,
    title: "EX DISPLAY : MSI Pro 16 Flex-036AU 15.6 MULTITOUCH All-In-On...",
    price: 600,
    offprice: 590,
    img: "assets/GamingMonitor/GamingMonitor.png",
    id: 44,
    categoryTitle: "gamingmonitor" ,
    tags : ['Monitor' , 'Msi' , 'Razor' , 'Gigabyte']  ,
  },
  
  
];
products.map(item=>{
  item.price=Math.ceil(Math.random()*20000) ; 
  item.offprice=item.price-(item.price*(Math.ceil(Math.random()*10)/100)) ; 
  item.id%2===0 ? item.tags.push('black') : item.tags.push('red') 
  if(item.img.includes('Laptop')){
    item.tags.push('Laptop')
  }
}) ;
export let newProducts = products.filter(item => item.categoryTitle === 'newCategory');
export let customBuildsProducts = products.filter(item => item.categoryTitle === "custombuilds");
export let MsiProductsInfo = products.filter(item => item.categoryTitle === "Msiproductinfo");
export let desktopProductsInfo = products.filter(item => item.categoryTitle === "Desktops");
export let gamingMonitorProducts = products.filter(item => item.categoryTitle === "gamingmonitor");
 

// fifth section product of home page 
export let gamingMonitor = [
  
];
export const filterOptions = [
  {
    title: "Category",
    items: ["Custom Pcs", "MSI All-IN-One Pcs", "HP/Compaq Pcs"],
  },
  {
    title: "Price",
    items:[
      [0,1000] , 
      [1000,2000] , 
      [3000,4000] , 
      [4000,5000] , 
      [5000,6000] , 
      [6000,7000] , 
      [7000,8000] , 
      [8000,9000] , 
      [9000,10000] , 
      [10000,11000] , 
      [11000,12000] , 
      [12000,13000] , 
      [13000,14000] , 
      [14000,15000] , 
      [15000,16000] , 
      [16000,17000] , 
      [17000,18000] , 
      [18000,19000] , 
      [19000,20000] , 
    ]
  },
  {
    title: "Color",
    items: ["black", "red"],
  },
  {
    title: "FilterName",
    items: ["Laptop", "Case", "Monitor"],
  },
  {
    title: "Brands",
    items: ["Msi", "Adata", "Razor", "Gigabyte"],
  },
];
export const filterItems = [
  "Category",
  "Price",
  "Color",
  "FilterName",
  "Brands",
];
